const instrumentsWithCategories = require('./instruments');

let items = ['none'];

function flatten(categories) {
  for (const idx in categories) {
    if (categories[idx].value) {
      const value = categories[idx].value.toLowerCase()
      items = items.concat([value])
    } else if (categories[idx].options) {
      flatten(categories[idx].options, items.concat(items))
    }
  }
}

flatten(instrumentsWithCategories)

module.exports = items;